export default "__VITE_ASSET__BA3z_Mx5__"